module.exports = __webpack_public_path__ + "img/banner-frame.f0dca453.png";